import { isType } from '../../helpers'
import Rule from './Rule'

export default class Imei extends Rule {
  get ruleName () {
    return 'imei'
  }

  passes () {
    let imei = this.value
    if (imei.length === 0) return true
    if (isType(imei, 'number')) imei = imei.toString()

    const etal = /^[0-9]{15}$/
    if (!etal.test(imei)) return false

    imei = [...imei].map((num, index) => (index % 2 === 0 ? num : `${num * 2}`))
      .map((num) => (num.length > 1
        ? parseInt(num[0]) + parseInt(num[1])
        : parseInt(num)))
      .reduce((acc, cur) => acc + cur)

    return imei % 10 === 0
  }
}
